var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { StoreContext } from '@/app/uistore/Rootstore';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { AppColor, FontSize } from '@/app/const/AppDefaults';
import { ScaleLoader } from 'react-spinners';
const AdminFloatingDatasheet = React.lazy(async () => await import("./AdminFloatingDatasheet"));
import { MdLink } from '@react-icons/all-files/md/MdLink';
import { testIsMobile } from '@@/Util';
let AdminFloatingDatasheetViewer = class AdminFloatingDatasheetViewer extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.adminFloatingDatasheetStore.setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.floatingDatasheetStore.dragging) {
                // lets move this dialog 
                rstore.adminFloatingDatasheetStore.setTop(e.clientY - this.adjusty);
                rstore.adminFloatingDatasheetStore.setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    addLink() {
    }
    render() {
        const rstore = this.context;
        if (!rstore.adminFloatingDatasheetStore.show) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { "object-viewer": 'colorbox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.adminFloatingDatasheetStore.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("object-viewer")) {
                    rstore.adminFloatingDatasheetStore.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.adminFloatingDatasheetStore.left + "px", top: rstore.adminFloatingDatasheetStore.top + "px", width: rstore.adminFloatingDatasheetStore.width + "px", height: testIsMobile() ? (window.innerHeight - 150) + "px" : (window.innerHeight - 100) + "px" },
            React.createElement(Flex, { pos: 'relative', "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', "object-viewer": 'colorbox', height: "50px", width: '100%' },
                rstore.adminFloatingDatasheetStore.linkingmode && React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                    React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: 'Add Link', onClick: () => this.addLink() },
                        React.createElement(Icon, { w: '20px', h: '20px', color: AppColor.ActionMenuIcon, className: 'message-option-button', as: MdLink, ml: '1px' }),
                        React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, 'Add Link'))),
                React.createElement(Icon, { pos: 'absolute', right: '5px', ml: '20px', as: MdClose, color: AppColor.ResetFilter, h: '25px', w: '25px', _hover: { cursor: 'pointer' }, onClick: (e) => {
                        rstore.adminFloatingDatasheetStore.setShowDialog(false);
                        rstore.adminFloatingDatasheetStore.reset();
                    }, className: 'message-option-button' })),
            React.createElement(Suspense, { fallback: React.createElement(Flex, { flexDirection: 'column', style: { height: '100%' }, justify: 'center', align: 'center' },
                    React.createElement(ScaleLoader, { color: 'green' }),
                    React.createElement(Text, { style: { fontWeight: 'bold', fontSize: '15px' } }, "Intialising...")) },
                React.createElement(AdminFloatingDatasheet, null)));
    }
};
AdminFloatingDatasheetViewer.contextType = StoreContext;
AdminFloatingDatasheetViewer = __decorate([
    observer
], AdminFloatingDatasheetViewer);
export { AdminFloatingDatasheetViewer };
